import React, { createElement, Fragment } from "react";
import { Helmet } from "react-helmet";

import { Utilities } from "ducks/Utilities/index";

export default function UtilitiesPage(props) {
  return (
    <Fragment>
      <Helmet>
        <title>{"Utilities - Savant Power"}</title>
      </Helmet>
      {createElement(Utilities, props)}
    </Fragment>
  );
}
